import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';
import { observable, computed, action } from 'mobx';

@observer
class PriceIndicator extends Component {
  static propTypes = {
    x: PropTypes.number.isRequired,
    y: PropTypes.number.isRequired,
    label: PropTypes.string.isRequired,
    backgroundColor: PropTypes.string,
    textColor: PropTypes.string,
  };

  static defaultProps = {
    backgroundColor: null,
    textColor: '#000',
  };

  @action.bound setRef(ref) {
    this.textDomNode = ref;
  }

  @computed
  get textBB() {
    const { textDomNode } = this;
    return !textDomNode
      ? {
          height: 10,
          width: 10,
          x: 0,
          y: 0,
        }
      : textDomNode.getBBox();
  }

  @observable textDomNode = null;

  render() {
    const {
      x,
      y,
      label,
      backgroundColor,
      textColor,
      ...otherProps
    } = this.props;
    const padding = 8;
    const arrowSize = 10;
    const boxStyle = { fill: backgroundColor };

    // this props go into the background box
    const boxProps = {
      width: this.textBB.width + padding,
      height: this.textBB.height + padding,
      x: this.textBB.x - padding / 2,
      y: this.textBB.y - padding / 2,
      style: boxStyle,
    };

    // this props go into the arrow next to the box
    const arrowProps = {
      x: boxProps.x - arrowSize / 2,
      y: boxProps.y + boxProps.height / 2,
      width: arrowSize,
      height: arrowSize,
      style: {
        ...boxStyle,
      },
      // use the transform attr because of IE/edge
      transform: `rotate(-45, ${boxProps.x - arrowSize / 2}, ${boxProps.y +
        boxProps.height / 2})`,
    };

    return (
      <g {...otherProps} transform={`translate(${x}, ${y})`}>
        {backgroundColor && [
          <rect {...boxProps} key="box" />,
          <rect {...arrowProps} key="arrow" />,
        ]}
        <text
          ref={this.setRef}
          x={0}
          y={0}
          style={{ dominantBaseline: 'central', fill: textColor }}
          dominantBaseline="central"
        >
          {label}
        </text>
      </g>
    );
  }
}

export default PriceIndicator;
